import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

interface Alternative {
  title: string;
  description: string;
  link: string;
}

interface AlternativesBandProps {
  alternatives: Alternative[];
}

const AlternativesBand: React.FC<AlternativesBandProps> = ({ alternatives }) => {
  return (
    <motion.section
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8 }}
      className="bg-gradient-to-r from-gray-50 to-gray-100 py-16 mb-20 rounded-lg"
    >
      <div className="max-w-7xl mx-auto px-4">
        <h2 className="text-3xl font-bold text-gray-900 mb-4 text-center">
          Explore Alternatives
        </h2>
        <p className="text-lg text-gray-600 text-center mb-12">
          Not quite the right fit? Check out these related products.
        </p>

        <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
          {alternatives.map((alt, index) => (
            <motion.div
              key={index}
              whileHover={{ scale: 1.02 }}
              className="bg-white rounded-lg shadow-lg p-6 border-2 border-gray-200 hover:border-ctc-blue transition-all"
            >
              <h3 className="text-xl font-bold text-gray-900 mb-3">{alt.title}</h3>
              <p className="text-gray-600 mb-4">{alt.description}</p>
              <Link
                to={alt.link}
                className="inline-flex items-center text-ctc-blue font-semibold hover:text-ctc-blue-dark transition-colors group"
              >
                Learn More
                <ArrowRight size={20} className="ml-2 group-hover:translate-x-1 transition-transform" />
              </Link>
            </motion.div>
          ))}
        </div>

        <div className="text-center mt-12">
          <Link
            to="/filtration/inline"
            className="inline-flex items-center text-gray-700 font-semibold hover:text-ctc-blue transition-colors"
          >
            Not sure which series fits? Compare all in-line filters
            <ArrowRight size={20} className="ml-2" />
          </Link>
        </div>
      </div>
    </motion.section>
  );
};

export default AlternativesBand;
